import Marquee from "react-fast-marquee";

const words = ["Redeem", "Restore", "Revive", "Rebuild"];

export default function ScriptureMarquee() {
  return (
    <div className="relative py-10 border-y border-white/5 bg-[#0A0710] overflow-hidden">
      <Marquee speed={38} gradient gradientColor="#0A0710" gradientWidth={140} autoFill>
        {words.map((w, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display italic text-5xl md:text-7xl font-light text-transparent bg-clip-text bg-gradient-to-r from-[#D4AF37] via-[#9D4EDD] to-[#00E5FF] px-10">
              {w}
            </span>
            <span className="text-gold/40 text-3xl">✦</span>
          </div>
        ))}
      </Marquee>
    </div>
  );
}
